import type { MarkConfig } from '@tiptap/core';
import type { Mark_Type, RicosMarkExtension } from 'ricos-types';
import { createRicosMarkExtension } from 'wix-tiptap-extensions';

/**
 * Creates RicosExtension for unsupported mark, dynamically
 */
export const getUnsupportedMarkConfig = ({
  unsupportedMarkType,
  ...attrs
}: {
  unsupportedMarkType: string;
  attrs: Record<string, unknown>;
}): RicosMarkExtension =>
  createRicosMarkExtension({
    type: 'mark',
    groups: [],
    name: unsupportedMarkType as Mark_Type,
    createExtensionConfig: (): MarkConfig => ({
      name: unsupportedMarkType,
      addAttributes: () => attrs,
      addOptions: () => ({
        HTMLAttributes: {},
      }),
      parseHTML() {
        return [
          {
            tag: 'abbr',
          },
        ];
      },

      renderHTML() {
        return [
          'abbr',
          {
            title: `'${unsupportedMarkType}' decoration is not supported by editor. Check editor configuration.`,
            style: 'cursor: help',
          },
          0,
        ];
      },
    }),
  });
